import { initLayoutVars } from './modules/layout-vars';
import { initScrollState } from './modules/scroll-state';
import { initNewsletterReader } from './modules/newsletter-reader';
import { initCalendarModals } from './modules/calendar-modals';
import { initSidebarWidgets } from './modules/sidebar-widgets';
import { initCopyToClipboard } from './modules/copy-to-clipboard';
import { initEckoSheets } from './modules/ecko-sheets';
import { initEditionLanguage } from './modules/edition-language';
import { initToast } from './modules/toast';
import { initStoryShare } from './modules/story-share';
import { initAnalyticsV2 } from './modules/analytics-v2';

initLayoutVars();
initScrollState();
initNewsletterReader();
initEckoSheets();
initCalendarModals();
initSidebarWidgets();
initCopyToClipboard();
initToast();
initStoryShare();
initEditionLanguage();
initAnalyticsV2();

